import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _ from 'lodash';
import withPureRender from './withPureRender';
import withTranslation from './withTranslation';
import withUtils from './withUtils';
// const withProfiling from('./withProfiling')

export default (function (Component) {
  var extraWrappers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var composed = _.flowRight.apply(_, [
  // withProfiling,
  withPureRender, withTranslation, withUtils].concat(_toConsumableArray(extraWrappers)))(Component);
  composed._rawClass = Component;
  composed.getDisplayName = function () {
    return Component.displayName;
  };
  composed.propTypes = Component.propTypes;
  return composed;
});